<template>
  <DashboardBottomCardContent
    :callToActionButtonText="$t('L_contact_your_representative')"
    @callToActionCallback="contactRep = true"
  >
    <template #icon>
      <v-img
        :src="debtSuccessIcon"
        alt="debtsuccess-icon"
        width="65"
        max-width="65"
        role="presentation"
        class="ma-0"
      />
    </template>
    <template #content>
      <h4 role="heading" aria-level="3" class="ml-6">
        <span id="title" class="d-block font-weight-bold">{{ $t('L_congratulations') }}</span>
        <span class="d-block font-weight-regular">{{
          $t('L_you_have_achieved_your_goal_of_debt_freedom')
        }}</span>
      </h4>
    </template>
  </DashboardBottomCardContent>
  <ContactRep
    v-if="hasReps"
    v-model="contactRep"
    :agents="globalStore.agents"
    @close="contactRep = false"
    @send-message="sendRepEmail($event)"
    close-selector="contact_your_rep_myrep_close"
    modal-class="contact_your_rep_myrep_modal"
    :sender="sender"
  />
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import ContactRep from '@/components/ContactRep/ContactRep.vue';
import debtSuccessIcon from '../assets/debt-success.svg';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useGlobalStore } from '@/stores/global/global.store';
import DashboardBottomCardContent from '../../DashboardBottomCardContent.vue';
import { mapStores } from 'pinia';
import type { IContactRepPayload } from '@/shared/api/models.bff.ts';
import { $t } from '@/i18n/i18n.ts';

const componentOptions: ComponentOptions = {
  name: 'DebtSolutionsCongratsBottom',
  components: {
    DashboardBottomCardContent,
    ContactRep,
  },
  data: () => ({
    contactRep: false,
    debtSuccessIcon,
  }),
  methods: {
    $t,
    async sendRepEmail(emailPayload: IContactRepPayload) {
      await this.customerStore.contactRepresentative(emailPayload);
    },
  },
  computed: {
    ...mapStores(useGlobalStore, useCustomerStore),
    sender() {
      return {
        email: this.customerStore.customerProfile.email || '',
        phone: this.customerStore.customerProfile.mobilePhone || '',
        firstName: this.customerStore.customerProfile.firstName,
        lastName: this.customerStore.customerProfile.lastName,
      };
    },
    hasReps() {
      return this.globalStore.agents.length > 0;
    },
    agent() {
      return this.globalStore.agents.length > 0 ? this.globalStore.agents[0] : {};
    },
  },
};
export default defineComponent(componentOptions);
</script>
